import { render, staticRenderFns } from "./RecycleTypeChart.vue?vue&type=template&id=6d994565&scoped=true"
import script from "./RecycleTypeChart.vue?vue&type=script&lang=js"
export * from "./RecycleTypeChart.vue?vue&type=script&lang=js"
import style0 from "./RecycleTypeChart.vue?vue&type=style&index=0&id=6d994565&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d994565",
  null
  
)

export default component.exports